module.exports = __webpack_public_path__ + "static/media/plant.1b963b39.jpg";